import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { SideMenuPopular } from '@/components/modules/Layout/SideMenu/SideMenuPopular/SideMenuPopular';
import { ArticleLinkList } from '@/components/modules/pages/article/List/ArticleLinkList';
import { ArticleListHead } from '@/components/modules/pages/article/Typography/Heading/ArticleListHead';
import { TagButtonList, TagButtonListSkeleton, } from '@/components/ui/List/TagButtonList';
import { SEMINAR_LIST_FILTER_TYPES } from '@/define/consts/seminar/seminar_list';
import { propArrayShape, propArrayStr, propBool, propFunc, propId, propOneOf, propShape, propStr, } from '@/helpers/custom-prop-types';
import ClientSeminarListLayout from './ClientSeminarListLayout';
import TypeFilter from './Filter/TypeFilter';
import ClientSeminarItems from './Items/ClientSeminarItems';
const ClientSeminarListView = (props) => {
    const { PopularCaseLoading, activeCategory, articleLinkListItems, formatQuery, hideDocumentModal, hideRegistrationModal, images, isGuestUser, isLoadingSeminarCategories, isPreview, isProfessionalUser, isShowDocumentModal, isShowRegistrationModal, loading, onChangeDocumentImage, onChangeTypeFilter, onClickCategory, onClickDocumentLink, onClickSearchResult, onLoadMoreSeminars, paging, pathname, popularArticlePageLoading, popularArticlePages, popularCases, popularProfessionalLoading, popularProfessionals, popularProfessionalsLink, previewId, seminarCategories, showRegistrationModal, userType, } = props;
    const pans = useMemo(() => {
        const setPans = [
            {
                text: 'セミナー',
            },
        ];
        if (!isGuestUser) {
            setPans.unshift({
                link: '/mypage',
                text: 'マイページ',
            });
        }
        return setPans;
    }, [isGuestUser]);
    return (_jsx(ClientSeminarListLayout, Object.assign({ breadcrumbItems: pans, hideDocumentModal: hideDocumentModal, hideRegistrationModal: hideRegistrationModal, images: images, isGuestUser: isGuestUser, isShowDocumentModal: isShowDocumentModal, isShowRegistrationModal: isShowRegistrationModal, mainClassName: clsx('l-main', 'client_seminar', 'seminar_list_container', 'seminar_common_container', isGuestUser && 'no-need-bottom-space'), onChangeDocumentImage: onChangeDocumentImage }, { children: _jsxs("div", Object.assign({ className: clsx('seminar_container', 'gap-80 lg:gap-48') }, { children: [_jsxs("div", Object.assign({ className: 'seminar_container_main' }, { children: [_jsx(ArticleLinkList, { className: clsx('mb-16'), items: articleLinkListItems, pathname: pathname }), (() => {
                            // loading
                            if (isLoadingSeminarCategories && !seminarCategories.length) {
                                return _jsx(TagButtonListSkeleton, { className: 'mb-24', count: 6 });
                            }
                            // 0件表示
                            if (!seminarCategories.length) {
                                return null;
                            }
                            // 通常表示
                            return (_jsx(TagButtonList, { activeValue: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.value, className: 'mb-24', items: seminarCategories, onClick: onClickCategory }));
                        })(), _jsxs("div", Object.assign({ className: clsx('w-full', 'flex flex-wrap gap-16 items-center') }, { children: [_jsx(ArticleListHead, { category: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.name, className: clsx('mr-auto', 'shrink-0', 'lg:whitespace-nowrap'), title: 'セミナー' }), _jsx(TypeFilter, { filters: SEMINAR_LIST_FILTER_TYPES, onChange: onChangeTypeFilter, types: formatQuery.types })] })), _jsx(ClientSeminarItems, { filteringTheme: formatQuery.theme, isPreview: isPreview, loading: loading, onClickDocumentLink: onClickDocumentLink, onClickMore: onLoadMoreSeminars, onClickSearchResult: onClickSearchResult, previewId: previewId, seminars: paging.articles, showMore: paging.articles.length > 0 && !paging.isLastPage, userType: userType })] })), isPreview ? (_jsx("div", { className: clsx('flex-shrink-0', 'w-full lg:w-[270px]') })) : (_jsx(SideMenuPopular, { className: clsx('flex-shrink-0', 'w-full lg:w-[270px]'), isGuestUser: isGuestUser, isLoadingPopularCase: PopularCaseLoading, isLoadingPopularConsultant: popularProfessionalLoading, isLoadingWeeklyRankingList: popularArticlePageLoading, isProfessionalUser: isProfessionalUser, onClickRegistration: showRegistrationModal, popularCases: popularCases, popularConsultantList: popularProfessionals, popularConsultantListHasMoreLink: popularProfessionalsLink, weeklyRankingList: popularArticlePages, weeklyRankingListLimit: 5 }))] })) })));
};
ClientSeminarListView.propTypes = {
    PopularCaseLoading: propBool().isRequired,
    activeCategory: propShape(),
    articleLinkListItems: propArrayShape().isRequired,
    formatQuery: propShape().isRequired,
    hideDocumentModal: propFunc().isRequired,
    hideRegistrationModal: propFunc().isRequired,
    images: propArrayStr().isRequired,
    isGuestUser: propBool().isRequired,
    isLoadingSeminarCategories: propBool().isRequired,
    isPreview: propBool().isRequired,
    isProfessionalUser: propBool().isRequired,
    isShowDocumentModal: propBool().isRequired,
    isShowRegistrationModal: propBool().isRequired,
    loading: propBool().isRequired,
    onChangeDocumentImage: propFunc().isRequired,
    onChangeTypeFilter: propFunc().isRequired,
    onClickCategory: propFunc().isRequired,
    onClickDocumentLink: propFunc().isRequired,
    onClickSearchResult: propFunc().isRequired,
    onLoadMoreSeminars: propFunc().isRequired,
    paging: propShape().isRequired,
    pathname: propStr().isRequired,
    popularArticlePageLoading: propBool().isRequired,
    popularArticlePages: propArrayShape(),
    popularCases: propArrayShape(),
    popularProfessionalLoading: propBool().isRequired,
    popularProfessionals: propArrayShape(),
    popularProfessionalsLink: propStr().isRequired,
    previewId: propId(),
    seminarCategories: propArrayShape(),
    showRegistrationModal: propFunc().isRequired,
    userType: propOneOf(['guest', 'client', 'professional']).isRequired,
};
ClientSeminarListView.defaultProps = {
    previewId: null,
    seminarCategories: [],
};
export default ClientSeminarListView;
